
<div class="alert alert-info">
  <!--<p><i class="fas fa-robot">&nbsp; >>&nbsp; </i>Based on today weather our machine learning bot recommend to buy <strong>{{prediction.prediction[0]}} </strong></p> -->
</div>





